import { render, staticRenderFns } from "./modalAddCustomer.vue?vue&type=template&id=2fe14078&"
import script from "./modalAddCustomer.vue?vue&type=script&lang=js&"
export * from "./modalAddCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports